<template>
    <ul
        v-auto-animate
        class="font-sans"
    >
        <li
            v-for="item in cart"
            :key="item.id"
            class="border-b border-gray-DFDFDF py-3 flex items-start sm:items-center justify-between gap-5"
        >
            <cart-modal-items-item :item="item" />

            <div class="h-16 sm:h-auto flex justify-between items-center flex-row">
                <base-button-flat
                    @click="editClub(item)"
                    variant="secondary"
                    class="h-10 px-3 uppercase"
                >
                    {{ $t('EDIT') }}
                </base-button-flat>

                <button
                    type="button"
                    @click="removeClubFromCart(item)"
                    aria-label="Remove"
                    title="Remove"
                    class="w-10 text-xl"
                >
                    &#10005;
                </button>
            </div>
        </li>
    </ul>
</template>

<script>
    import allStores from '../stores/all';

    import CartModalItemsItem from './CartModalItemsItem.vue';
    import BaseButtonFlat from './buttons/BaseButtonFlat.vue';

    export default {
        mixins: [allStores],

        components: {
            CartModalItemsItem,
            BaseButtonFlat,
        },

        computed: {
            cart() {
                return this.customizerStore.cart;
            },
        },

        methods: {
            editClub(item) {
                this.$emit('edit', item);
            },

            removeClubFromCart(item) {
                this.$emit('remove', item);
            },
        },
    };
</script>
